export const staticiC = {
  criteriaVoList: [{
    collection: true,
    column: '',
    endValue: '',
    expression: '',
    value: '',
    valueType: ''
  }],
  queryPageName: ''
}
export const updateStatus = {
  one: 0, // 创建部门
  two: 1, // 修改部门,
  three: 2,
  four: 3, // 添加
  five: 4
}
export const tree = {
  F_Id_Field: 'id',
  F_ParentId_Field: 'orgFatherId',
  Root_Id: 0
}
const twoTableContent = {
  // 出库单
  maintenance: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'deliverCount ',
    label: '发货数量'
  },
  {
    key: 'allPrice',
    label: '报价总额'
  }
  ], // 维修
  // 报价单πpππP
  quotation: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'allPrice',
    label: '报价总额'
  }
  ],

  //  销售非期货处理
  salce: [{
    key: 'proNumber',
    label: '产品种类'
  },

  {
    key: 'proTotal',
    label: '产品总额'
  }
  ],
  salce_futures: [
    {
      key: 'proNumber',
      label: '产品种类'
    },

    {
      key: 'proTotal',
      label: '产品总额'
    }
  ],
  // 采购
  procurement: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'priceTotals',
    label: '采购总额'
  },
  {
    key: 'discountTotals',
    label: '抵扣总额'
  },

  {
    key: 'actualTotal',
    label: '实付总额'
  }

  ],
  // 销售维修
  salesMaintenance: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'allMaintenance',
    label: '维修总额'
  }
  ],
  // 采购退货
  salesReturn: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'proTotal',
    label: '产品总额'
  }, {
    key: 'allForfeiture',
    label: '罚没总额'
  }
  ],
  OutboundOrder: [{
    key: 'proNumber',
    label: '产品种类'
  },
  {
    key: 'deliverCount',
    label: '发货数量'
  }, {
    key: 'allPrice',
    label: '报价总额'
  }
  ]

}

export function SelectwoTableContent (type) {
  switch (Number(type)) {
    case 1:

      return twoTableContent.quotation
    // break;
    // 非期货
    case 2:
      return twoTableContent.salce
    // 期货
    case 9:
      return twoTableContent.salce_futures
    // 采购
    case 3:
      return twoTableContent.procurement
    // 出库单
    case 4:
      return twoTableContent.salesMaintenance
    // 销售维修合同模板
    case 5:
      return twoTableContent.salesMaintenance
    // 销售退货
    case 6:
      return twoTableContent.salesReturn
    // 出库单合同模版
    case 7:

      return twoTableContent.salesReturn
    case 8:
      return twoTableContent.OutboundOrder
    default:

      break
  }
}

export const groupItem = {
  firstCharge: 0,
  firstChargeName: '',
  flag: true,
  id: 0,
  mark: '',
  orgCode: '',
  orgFatherId: 1,
  orgFatherPath: '',
  orgFatherPathIds: '',
  orgName: 'r',
  orgSerial: 0,
  secondCharge: 0,
  secondChargeName: ''
}

const templateItemContent = {
  // 采购维修
  buytemp: [

    {
      key: 'whole',
      label: '全部'
    },
    {
      key: 'templateProductListVo_index+1',
      label: '编号'
    },
    {
      key: 'brandName',
      label: '品牌'
    },
    {
      key: 'seriesName',
      label: '系列'
    },
    {
      key: 'proModel',
      label: '型号'
    },
    {
      key: 'proName',
      label: '产品名称'
    },

    {
      key: 'proOrdernum',
      label: '订货号'
    },
    {
      key: 'proUnit',
      label: '单位'
    },
    {
      key: 'count',
      label: '数量'
    },
    {
      key: 'maintenanceCost',
      label: '维修费用'
    }
  ],
  // 采购退货
  buyreturn: [
    {
      key: 'whole',
      label: '全部'
    },
    {
      key: 'templateProductListVo_index+1',
      label: '编号'
    },
    {
      key: 'brandName',
      label: '品牌'
    },
    {
      key: 'seriesName',
      label: '系列'
    },
    {
      key: 'proModel',
      label: '型号'
    },
    {
      key: 'proName',
      label: '产品名称'
    },

    {
      key: 'proOrdernum',
      label: '订货号'
    },
    {
      key: 'proUnit',
      label: '单位'
    },
    {
      key: 'count',
      label: '数量'
    },
    {
      key: 'proExtype',
      label: '类型'
    },
    {
      key: 'pcbExtimeValue',
      label: '货期'
    },
    {
      key: 'price',
      label: '产品单价'
    },
    {
      key: 'priceTotal',
      label: '产品总价'
    },
    {
      key: 'forfeitureCost',
      label: '罚没费用'
    },
    {

      key: 'sumtotal',
      label: '总计'
    }
  ],
  // 出库单模版
  Outbound: [
    {
      key: 'whole',
      label: '全部'
    },
    {
      key: 'templateProductListVo_index+1',
      label: '编号'
    },
    {
      key: 'brandName',
      label: '品牌'
    },
    {
      key: 'seriesName',
      label: '系列'
    },
    {
      key: 'proModel',
      label: '型号'
    },
    {
      key: 'proName',
      label: '产品名称'
    },

    {
      key: 'proOrdernum',
      label: '订货号'
    },
    {
      key: 'proUnit',
      label: '单位'
    },
    {
      key: 'count',
      label: '发货数量'
    },
    {
      key: 'price',
      label: '单品报价'
    },
    {
      key: 'priceTotal',
      label: '总报价'
    },
    {
      key: 'sumtotal',
      label: '总计'
    }
  ],
  // 销售非期货
  sale_notfun: [
    {
      key: 'whole',
      label: '全部'
    },
    {
      key: 'templateProductListVo_index+1',
      label: '编号'
    },
    {
      key: 'brandName',
      label: '品牌'
    },
    {
      key: 'seriesName',
      label: '系列'
    },
    {
      key: 'proModel',
      label: '型号'
    },
    {
      key: 'proName',
      label: '产品名称'
    },

    {
      key: 'proOrdernum',
      label: '订货号'
    },
    {
      key: 'proUnit',
      label: '单位'
    },
    {
      key: 'count',
      label: '数量'
    },
    // {
    //   key: 'proExtype',
    //   label: '类型'
    // },
    {
      key: 'pcbExtimeValue',
      label: '货期'
    },
    {
      key: 'price',
      label: '产品单价'
    },
    {
      key: 'priceTotal',
      label: '产品总价'
    },
    {
      key: 'sumtotal',
      label: '总计'
    }

  ],
  offercontent: [{
    key: 'whole',
    label: '全部'
  },
  {
    key: 'templateProductListVo_index+1',
    label: '编号'
  },
  {
    key: 'brandName',
    label: '品牌'
  },
  {
    key: 'seriesName',
    label: '系列'
  },
  {
    key: 'proModel',
    label: '型号'
  },
  {
    key: 'proName',
    label: '产品名称'
  },

  {
    key: 'proOrdernum',
    label: '订货号'
  },
  {
    key: 'proUnit',
    label: '单位'
  },
  {
    key: 'count',
    label: '数量'
  },
  {
    key: 'proPrice',
    label: '产品面价'
  }, {
    key: 'price',
    label: '单品报价'
  },
  // {
  //   key: 'proExtype',
  //   label: '类型'
  // },
  {
    key: 'pcbExtimeValue',
    label: '货期（天）'
  },
  {
    key: 'priceTotal',
    label: '总报价'
  },

  {
    key: 'sumtotal',
    label: '总计'
  }],
  // 采购
  pushsmain: [{
    key: 'whole',
    label: '全部'
  },
  {
    key: 'templateProductListVo_index+1',
    label: '编号'
  },
  {
    key: 'brandName',
    label: '品牌'
  },
  {
    key: 'seriesName',
    label: '系列'
  },
  {
    key: 'proModel',
    label: '型号'
  },
  {
    key: 'proName',
    label: '产品名称'
  },

  {
    key: 'proOrdernum',
    label: '订货号'
  },
  {
    key: 'proUnit',
    label: '单位'
  },
  {
    key: 'count',
    label: '数量'
  },
  {
    key: 'proExtype',
    label: '类型'
  },
  {
    key: 'pcbExtimeValue',
    label: '货期'
  },
  {
    key: 'price',
    label: '采购单价'
  },

  {
    key: 'discountPrice',
    label: '折扣金额'
  },
  {
    key: 'actuallyPirce',
    label: '实付单价'
  },
  {
    key: 'purchasePrices',
    label: '实付总价'
  },
  {
    key: 'sumtotal',
    label: '总计'
  }
  ]
}

// 文件模版管理
export const selectSumTemplate = (type) => {
  switch (type) {
    // 报价单
    case 1:
      return templateItemContent.offercontent
    // 采购维修
    case 5:
      return templateItemContent.buytemp
    // 采购退货
    case 7:
      return templateItemContent.buyreturn
    // 销售维修
    case 4:
      return templateItemContent.buytemp
    // 销售退货
    case 6:
      return templateItemContent.buyreturn

    // 销售非期货
    case 2:
      return templateItemContent.sale_notfun
    // 销售期货
    case 9:
      return templateItemContent.sale_notfun
    // 出库单模版
    case 8:

      return templateItemContent.Outbound
    // 采购
    case 3:
      return templateItemContent.pushsmain
      // break;
    default:
      break
  }
}

export const replateStr = (targetStr, origStr) => {
  return targetStr.replace(
    targetStr.substring((targetStr.substring(0, targetStr.lastIndexOf('</')).lastIndexOf('>') + 1), targetStr.lastIndexOf('</')), targetStr.substring((targetStr.substring(0, targetStr.lastIndexOf('</')).lastIndexOf('>') + 1), targetStr.lastIndexOf('</')) + '${(' + origStr + ')!}')
}
const SumItem = {
  customer: {
    title: {
      selectTitle: '插入客户信息',
      selectTwoTitle: '插入报价信息',
      selectThreeTitle: '插入公司信息'
    },
    quotation: [{
      id: 1,
      fname: '客户名称',
      wildCard: 'customer_name',
      title: ',1,2,4,6'
    },
    {
      id: 2,
      fname: '联系人',
      wildCard: 'linkman',
      title: ',1,2,4,6,5,7,3'
    },
    {
      id: 3,
      fname: '联系电话',
      wildCard: 'phone',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 4,
      fname: '详细地址',
      wildCard: 'address',
      title: ',1,2,4,6,5,7,3'
    }
    ],
    OfferList: [

      {
        id: 8,
        fname: '报价日期',
        wildCard: 'offer_date',
        title: ',1'
      },
      {
        id: 9,
        fname: '报价单号',
        wildCard: 'offer_number',
        title: ',1'
      },
      {
        id: 10,
        fname: '物流方式',
        wildCard: 'logistic_mode',
        title: ',1.4,6,5,7'
      },
      {
        id: 11,
        fname: '快递公司/物流公司 ',
        wildCard: 'company_express',
        title: ',1,2,4,6,5,7'
      },
      {
        id: 12,
        fname: '物流费用',
        wildCard: 'logistic_cost',
        title: ',1'
      },
      {
        id: 13,
        fname: '销售员',
        wildCard: 'sales',
        title: ',1'
      },
      {
        id: 24,
        fname: '产品列表',
        wildCard: 'product_list',
        title: ',1,2,4,6,8,5,7,3'
      }
    ],
    group: [{
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    },
    {
      id: 6,
      fname: '公司名称',
      wildCard: 'company_name',
      title: ',1'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },
    {
      id: 6,
      fname: '公司邮箱',
      wildCard: 'company_mail',
      title: ',1'
    }
    ]
  },
  // 销售模版
  sale: {
    title: {
      selectTitle: '插入客户信息',
      selectTwoTitle: '插入合同信息',
      selectThreeTitle: '插入公司信息'
    },
    quotation: [
      {
        id: 1,
        fname: '客户名称',
        wildCard: 'customer_name',
        title: ',1,2,4,6'
      },
      {
        id: 2,
        fname: '联系人',
        wildCard: 'linkman',
        title: ',1,2,4,6,5,7,3'
      },
      {
        id: 3,
        fname: '联系电话',
        wildCard: 'phone',
        title: ',1,2,4,6,8,5,7,3'
      },
      {
        id: 4,
        fname: '详细地址',
        wildCard: 'address',
        title: ',1,2,4,6,5,7,3'
      },
      {
        id: 36,
        fname: '税号',
        wildCard: 'duty',
        title: ',2,3,9'
      },
      {
        id: 15,
        fname: '银行账号',
        wildCard: 'bank_account',
        title: ',2,4,6,5,7,3,9'
      },
      {
        id: 16,
        fname: '开户银行',
        wildCard: 'bank_open',
        title: ',2,4,6,5,7,3,9'
      }

    ],
    OfferList: [
      {
        id: 18,
        fname: '合同金额',
        wildCard: 'contract_money',
        title: ',2,4,6,5,7,3'
      },
      {
        id: 19,
        fname: '合同大写金额',
        wildCard: 'contract_big_money',
        title: ',2,4,6,5,7,3'
      },

      {
        id: 20,
        fname: '合同编号',
        wildCard: 'contract_number',
        title: ',2,4,6,5,7,3'
      },
      {
        id: 21,
        fname: '签订时间',
        wildCard: 'begin_date',
        title: ',2,4,6,5,7,3'
      },
      {
        id: 22,
        fname: '付款类型',
        wildCard: 'pay_type',
        title: ',2,3'
      },
      {
        id: 10,
        fname: '物流方式',
        wildCard: 'logistic_mode',
        title: ',1.4,6,5,7'
      },
      {
        id: 11,
        fname: '物流公司 ',
        wildCard: 'company_express',
        title: ',1,2,4,6,5,7'
      },
      {
        id: 23,
        fname: '交货设置',
        wildCard: 'deliver_set',
        title: ',2,3'
      },
      {
        id: 24,
        fname: '产品列表',
        wildCard: 'product_list',
        title: ',1,2,4,6,8,5,7,3'
      },
      {
        id: 37,
        fname: '补充说明',
        wildCard: 'replenMark',
        title: ',2,3,9'
      }
    ],
    group: [{
      id: 14,
      fname: '公司名称',
      wildCard: 'company_name',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },
    {
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    },
    {
      id: 6,
      fname: '公司邮箱',
      wildCard: 'company_mail',
      title: ',1'
    }
    ]
  },
  // 采购合同模版
  purchasSum: {
    title: {
      selectTitle: '插入供应商信息',
      selectTwoTitle: '插入合同信息',
      selectThreeTitle: '插入公司信息'
    },
    group: [{
      id: 6,
      fname: '公司邮箱',
      wildCard: 'company_mail',
      title: ',1'
    },
    {
      id: 14,
      fname: '公司名称',
      wildCard: 'company_name',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },
    {
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    }
    ],
    // 供应商合同
    quotation: [

      {
        id: 2,
        fname: '联系人',
        wildCard: 'linkman',
        title: ',1,2,4,6,5,7,3'
      },
      {
        id: 3,
        fname: '联系电话',
        wildCard: 'phone',
        title: ',1,2,4,6,8,5,7,3'
      },
      {
        id: 4,
        fname: '详细地址',
        wildCard: 'address',
        title: ',1,2,4,6,5,7,3'
      },

      {
        id: 33,
        fname: '供应商名称',
        wildCard: 'supplier_name',
        title: ',5,7,3'
      },
      {
        id: 36,
        fname: '税号',
        wildCard: 'duty',
        title: ',2,3,9'
      },
      {
        id: 15,
        fname: '银行账号',
        wildCard: 'bank_account',
        title: ',2,4,6,5,7,3,9'
      },
      {
        id: 16,
        fname: '开户银行',
        wildCard: 'bank_open',
        title: ',2,4,6,5,7,3,9'
      }

    ],
    OfferList: [{
      id: 17,
      fname: '合同名称',
      wildCard: 'contract_name',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 18,
      fname: '合同金额',
      wildCard: 'contract_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 19,
      fname: '合同大写金额',
      wildCard: 'contract_big_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 20,
      fname: '合同编号',
      wildCard: 'contract_number',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 21,
      fname: '开始时间',
      wildCard: 'begin_date',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 22,
      fname: '付款类型',
      wildCard: 'pay_type',
      title: ',2,3'
    },
    {
      id: 23,
      fname: '交货设置',
      wildCard: 'deliver_set',
      title: ',2,3'
    },
    {
      id: 24,
      fname: '产品列表',
      wildCard: 'product_list',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 37,
      fname: '补充说明',
      wildCard: 'replenMark',
      title: ',2,3,9'
    }
    ]
  },
  // 采购维修&&采购退货模版
  Purchase: {
    title: {
      selectTitle: '插入供应商信息',
      selectTwoTitle: '插入合同信息',
      selectThreeTitle: '插入公司信息'
    },
    OfferList: [{
      id: 17,
      fname: '合同名称',
      wildCard: 'contract_name',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 18,
      fname: '合同金额',
      wildCard: 'contract_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 19,
      fname: '合同大写金额',
      wildCard: 'contract_big_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 20,
      fname: '合同编号',
      wildCard: 'contract_number',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 21,
      fname: '开始时间',
      wildCard: 'begin_date',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 22,
      fname: '付款类型',
      wildCard: 'pay_type',
      title: ',2,3'
    },
    {
      id: 23,
      fname: '交货设置',
      wildCard: 'deliver_set',
      title: ',2,3'
    },
    {
      id: 24,
      fname: '产品列表',
      wildCard: 'product_list',
      title: ',1,2,4,6,8,5,7,3'
    }
    ],
    group: [{
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    },
    {
      id: 6,
      fname: '公司邮箱',
      wildCard: 'company_mail',
      title: ',1'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },
    {
      id: 6,
      fname: '公司邮箱',
      wildCard: 'company_mail',
      title: ',1'
    }
    ],
    quotation: [{
      id: 2,
      fname: '联系人',
      wildCard: 'linkman',
      title: ',1,2,4,6,5,7,3'
    },
    {
      id: 3,
      fname: '联系电话',
      wildCard: 'phone',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 4,
      fname: '详细地址',
      wildCard: 'address',
      title: ',1,2,4,6,5,7,3'
    },

    {
      id: 33,
      fname: '供应商名称',
      wildCard: 'supplier_name',
      title: ',5,7,3'
    }

    ]

  },
  // 销售退货模版&&销售维修模版s
  SalesReturn: {
    title: {
      selectTitle: '插入客户信息',
      selectTwoTitle: '插入合同信息',
      selectThreeTitle: '插入公司信息'
    },
    quotation: [

      {
        fname: '客户名称',
        wildCard: 'customer_name'
      },
      {
        fname: '联系人',
        wildCard: 'linkman'
      }, {
        fname: '联系电话',
        wildCard: 'phone'

      },
      {
        fname: '详细地址',
        wildCard: 'address'
      }
    ],
    OfferList: [{
      id: 24,
      fname: '产品列表',
      wildCard: 'product_list',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 17,
      fname: '合同名称',
      wildCard: 'contract_name',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 18,
      fname: '合同金额',
      wildCard: 'contract_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 19,
      fname: '合同大写金额',
      wildCard: 'contract_big_money',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 20,
      fname: '合同编号',
      wildCard: 'contract_number',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 21,
      fname: '签订时间',
      wildCard: 'begin_date',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 10,
      fname: '物流方式',
      wildCard: 'logistic_mode',
      title: ',1.4,6,5,7'
    },
    {
      id: 11,
      fname: '物流公司 ',
      wildCard: 'company_express',
      title: ',1,2,4,6,5,7'
    }
    ],
    group: [{
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },

    {
      id: 14,
      fname: '公司名称',
      wildCard: 'company_name',
      title: ',2,4,6,5,7,3'
    }
    ]
  },
  // 出库单
  OutboundOrder: {
    title: {
      selectTitle: '插入客户信息',
      selectTwoTitle: '插入模版信息',
      selectThreeTitle: '插入公司信息'
    },
    group: [{
      id: 5,
      fname: '公司地址',
      wildCard: 'company_address',
      title: ',1,2,4,6'
    },
    {
      id: 7,
      fname: '公司电话',
      wildCard: 'company_phone',
      title: ',1,2,4,6'
    },

    {
      id: 14,
      fname: '公司名称',
      wildCard: 'company_name',
      title: ',2,4,6,5,7,3'
    }
    ],
    quotation: [{
      id: 1,
      fname: '客户名称',
      wildCard: 'customer_name',
      title: ',1,2,4,6'
    },
    {
      id: 2,
      fname: '收货人',
      wildCard: 'linkman',
      title: ',1,2,4,6,5,7,3'
    },
    {
      id: 3,
      fname: '收货人联系电话',
      wildCard: 'shipping_phone',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 4,
      fname: '收货地址',
      wildCard: 'address',
      title: ',1,2,4,6,5,7,3'
    }
    ],

    OfferList: [{
      id: 21,
      fname: '制单时间',
      wildCard: 'begin_date',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 13,
      fname: '销售员',
      wildCard: 'sales',
      title: ',1'
    },
    {
      id: 24,
      fname: '产品列表',
      wildCard: 'product_list',
      title: ',1,2,4,6,8,5,7,3'
    },
    {
      id: 20,
      fname: '发货编号',
      wildCard: 'contract_number',
      title: ',2,4,6,5,7,3'
    }, {
      id: 999,
      fname: '销售员电话',
      wildCard: 'contract_number',
      title: ',2,4,6,5,7,3'
    },
    {
      id: 28,
      fname: '备注',
      wildCard: 'shipping_mark',
      title: ',8,9'
    }
    ]

  }
}

/**
 0: {id: 5, templateName: "采购维修合同模板", createDate: 1602496714000, createIp: 0, createUser: "",…}
 1: {id: 2, templateName: "销售合同模板(非期货)", createDate: 1602496247000, createIp: 0, createUser: "",…}
 2: {id: 9, templateName: "销售合同模板(期货)", createDate: 1602495748000, createIp: null, createUser: null,…}
 3: {id: 3, templateName: "采购合同模板", createDate: 1602495723000, createIp: 0, createUser: "",…}
 4: {id: 1, templateName: "报价单模板", createDate: 1602494567000, createIp: 0, createUser: "",…}
 5: {id: 4, templateName: "销售维修合同模板", createDate: null, createIp: null, createUser: null, lastDate: null,…}
 6: {id: 6, templateName: "销售退货合同模板", createDate: null, createIp: null, createUser: null, lastDate: null,…}
 7: {id: 7, templateName: "采购退货合同模板", createDate: null, createIp: null, createUser: null, lastDate: null,…}
 8: {id: 8, templateName: "出库单模板", createDate: null, createIp: null, c
 * @param {*} type
 */
export const seltOne = (type) => {
  switch (type) {
    case 1:
      // 报价单
      return SumItem.customer
    // break;
    case 2:
      // 销售合同模版非期货
      return SumItem.sale
    case 9:
      // 销售合同模版期货
      return SumItem.sale
    // break;
    case 3:
      // 采购合同模版

      return SumItem.purchasSum
      // break;

    case 4:
      // 销售维修模版

      return SumItem.SalesReturn
    // break;
    case 5:
      // 采购维修模版
      return SumItem.Purchase
    // break;
    case 6:
      // 销售退货
      return SumItem.SalesReturn
    // break;
    case 7:
      // 采购退货
      return SumItem.Purchase
    case 8:
      // 出库单
      return SumItem.OutboundOrder
      // break;

    default:
      break
  }
}
